import { API_BASE_URL } from "./apiConfig";
import { handleApiResponse } from "./apiUtils";

export const submitQuizResult = async (resultData) => {
  const response = await fetch(`${API_BASE_URL}/quiz-results`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'accept': '*/*',
    },
    body: JSON.stringify(resultData),
  });
  return handleApiResponse(response);
};

export const getQuizResultById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/quiz-results/${id}`, {
    headers: {
      'accept': '*/*',
    },
  });
  return handleApiResponse(response);
};

export const updateQuizResult = async (id, resultData) => {
  const response = await fetch(`${API_BASE_URL}/quiz-results/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'accept': '*/*',
    },
    body: JSON.stringify(resultData),
  });
  return handleApiResponse(response);
};

export const deleteQuizResult = async (id) => {
  const response = await fetch(`${API_BASE_URL}/quiz-results/${id}`, {
    method: 'DELETE',
    headers: {
      'accept': '*/*',
    },
  });
  return handleApiResponse(response);
};

export const getQuizResultsByUserId = async (userId) => {
  const response = await fetch(`${API_BASE_URL}/quiz-results/user/${userId}`, {
    headers: {
      'accept': '*/*',
    },
  });
  return handleApiResponse(response);
};

export const getQuizResultsByModuleId = async (moduleId) => {
  const response = await fetch(`${API_BASE_URL}/quiz-results/module/${moduleId}`, {
    headers: {
      'accept': '*/*',
    },
  });
  return handleApiResponse(response);
};

export const getQuizResultsReport = async (userId) => {
  let url = `${API_BASE_URL}/quiz-results/report`;
  if (userId) {
    url += `?userId=${encodeURIComponent(userId)}`;
  }
  const response = await fetch(url, {
    headers: {
      'accept': '*/*',
    },
  });
  return handleApiResponse(response);
};
